export default "__VITE_PUBLIC_ASSET__63731d2f__"